import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { zIndex } from '@doltech/utils/lib/constants';
import styled from 'styled-components';

export const LISTENING_CONTENT_BOX_WIDTH = 712;

export const ListeningTestLayout = styled.section<{ expanded?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  background-color: ${colorsV2.gray10};

  .btn-back-with-logo-icon {
    position: absolute;
    top: 16px;
    left: 32px;
  }

  #body-container {
    height: 100%;
    overflow: auto;
    flex: 1;
    width: 100%;
    z-index: ${zIndex.TEST_CONTENT};

    transition: all 0.3s ease;
    #body-content {
      width: 100%;
      padding: 16px 0;
      margin: 0 auto;
      .header-container,
      .test-content-container,
      .dol-question {
        position: relative;
        width: ${LISTENING_CONTENT_BOX_WIDTH}px;
        margin: 0 auto 12px;
      }

      .test-content-container {
        z-index: ${zIndex.TEST_CONTENT};
      }
    }
  }
`;
